import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import getRoutes from './Routes/Routes';
import './assets/scss/style.scss';
import './assets/scss/common/Responsive.scss';

import { AuthProvider } from './Modules/Core/Context/AuthContext';

import AuthGaurd from './Modules/Core/Components/AuthGaurd/AuthGaurd';
import {
  Loader,
  ErrorFallback,
  GlobalProvider,
  AppNotifications,
} from 'smart-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import MetaTags from './Modules/Core/Components/MetaTags/Tags';
const DrawerRouterContainer = React.lazy(
  () =>
    import(
      /* webpackPreload: true */ './Modules/Core/Components/Drawer/DrawerRouterContainer'
    )
);

function App() {
  const queryClient = new QueryClient();
  return (
    <React.Suspense fallback={<Loader />}>
      <React.Suspense>
        <MetaTags />
      </React.Suspense>
      <GlobalProvider>
        <ErrorBoundary
          FallbackComponent={ErrorFallback}
          onReset={() => {
            // reset the state of your app so the error doesn't happen again
          }}
        >
          <React.Suspense>
            <AppNotifications />
          </React.Suspense>
        </ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<AuthGaurd />}>
                  <Route path="/" element={<DrawerRouterContainer />}>
                    {getRoutes('TileLayout')}
                    {getRoutes('CardLayout')}
                  </Route>
                  {getRoutes('AuthEmptyLayout')}
                </Route>
                {getRoutes('EmptyLayout')}
              </Routes>
            </BrowserRouter>
          </AuthProvider>
          {process.env.APP_ENV === 'dev' && (
            <ReactQueryDevtools initialIsOpen={false} />
          )}
        </QueryClientProvider>
      </GlobalProvider>
    </React.Suspense>
  );
}

export default App;
